import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { generateConfig } from "../../utils/api";
import { handleApiError } from "../../utils/apiErrorHandler";

export const fetchPlacesOfService = createAsyncThunk(
  "placeOfService/fetchPlacesOfService",
  async (params = {}, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const queryParams = new URLSearchParams();
      if (params.search) queryParams.append("search", params.search);
      if (params.active !== undefined) queryParams.append("active", params.active);

      const response = await axios.get(
        `${baseURL}/api/place-of-service?${queryParams.toString()}`,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const createPlaceOfService = createAsyncThunk(
  "placeOfService/createPlaceOfService",
  async (data, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.post(
        `${baseURL}/api/place-of-service`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const updatePlaceOfService = createAsyncThunk(
  "placeOfService/updatePlaceOfService",
  async ({ id, data }, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      const response = await axios.put(
        `${baseURL}/api/place-of-service/${id}`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const deletePlaceOfService = createAsyncThunk(
  "placeOfService/deletePlaceOfService",
  async (id, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });

      await axios.delete(`${baseURL}/api/place-of-service/${id}`, config);
      return id;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);
